export enum GeoConversionTypes {
    Wgs84 = 'wgs84',
    Rds = 'rds', // Rijksdriehoekstelsel
    None = 'none',
}
